// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"b4bd0a9e","927":"fe9acf1a"}[chunkId] + ".chunk.css";
};